// Compose and send a manual push notification (+ in-app feed item) to a chosen
// audience: all players, a sport league's members, or a mini league. Pick where a
// tap lands (any in-app screen), preview the audience with a dry run, then send.
// Password-gated end to end via the `sendBroadcast` callable.
import { useMemo } from 'react';
import { PageTitle, useAdminData } from '../parts';
import { BroadcastActionsPanel } from './BroadcastActionsPanel';
import { BroadcastComposePanels } from './BroadcastComposePanels';
import { useBroadcastForm } from './useBroadcastForm';

export default function BroadcastScreen() {
  const { password, data } = useAdminData();
  const leagues = useMemo(
    () => [...data.leagues].sort((a, b) => b.memberCount - a.memberCount),
    [data.leagues]
  );
  const miniLeagues = useMemo(
    () => [...data.miniLeagues].sort((a, b) => b.memberCount - a.memberCount),
    [data.miniLeagues]
  );

  const form = useBroadcastForm(password, leagues, miniLeagues, data.stats.totalUsers);

  return (
    <>
      <PageTitle title="Broadcast" sub="Send a push notification to players" />

      <div className="grid gap-5 lg:grid-cols-[1fr_360px]">
        <div className="flex flex-col gap-5">
          <BroadcastComposePanels form={form} leagues={leagues} miniLeagues={miniLeagues} />
        </div>
        <div className="flex flex-col gap-5">
          <BroadcastActionsPanel form={form} />
        </div>
      </div>
    </>
  );
}
